import { useState, useEffect, useRef } from "react";
import {
    Table,
    Input,
    Button,
    Spin,
    Modal,
    Select,
    Drawer,Space
} from "antd";
import { message } from "../../components/antdMessageBridge";
import { useLocation, useNavigate } from "react-router-dom";
import CommonObj from "../../CommonObj";
import Html5QrcodePlugin from "../qrscanner/qrscanner";
import { useAuthToken } from "../../components/usecontext/AuthContext";
import ManifestCreation1Icon from "../../assets/img/svg/xmanifestacceptanceicon3.svg";
import "../manifest-creation/manifestcreation.css";
import { useAuth } from "../../auth/AuthContext";
import { Html5QrcodeScanType } from "html5-qrcode";
import configJson from "../../Config.json";
import { encryptTimestamp } from "../../components/commoncsrf/csrf-common";
import { Option } from "antd/es/mentions";
import "./exception-action.css";
import ConfirmationModal from "../../components/confirmationmodal/confirmation-modal";
import RecoverSlide from "./recover-slide";
import validationService from "../../components/commonvalidation/validationService";
import { showManualEntryDisabledWarning } from "../../components/commonvalidation/manualEntryWarning";
import useFieldPermissions from "../../hooks/useFieldPermissions";

const ExceptionBookAction = () => {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [form, setForm] = useState({
        bid: "",
        isbn: "",
    });
    const [recoverData, setRecoverdata] = useState({});
    const [showRecoverModal, setShowRecoverModal] = useState(false);
    const { roleUserId } = useAuth();

    const { accessToken } = useAuthToken();
    const [cusdectext, setCusDecText] = useState("");
    const [isDisabled, setIsDisabled] = useState(false);
    const [exceptionActionStatuses, setExceptionActionStatuses] = useState([]);
    const [moveToStationValues, setMoveToStationValues] = useState([]);
    const [selectedAction, setSelectedAction] = useState(null);
    const [drawerVisible, setDrawerVisible] = useState(false);
    const [errors, setErrors] = useState({});
    const { isReadOnly } = useFieldPermissions("exceptionAction");

    const isProcessingRef = useRef(false);
    const lastProcessedValueRef = useRef("");
    const timeoutRef = useRef(null);
    const activeScannerRef = useRef(null);
    const lastBidKeyTimeRef = useRef(0);
    const clearBidTimerRef = useRef(null);
    const lastIsbnKeyTimeRef = useRef(0);
    const clearIsbnTimerRef = useRef(null);

    useEffect(() => {
        return () => {
            clearTimeout(clearBidTimerRef.current);
            clearTimeout(clearIsbnTimerRef.current);
        };
    }, []);

    const location = useLocation();
    const isbnkey = location?.state || "";
    const bid = location.state?.bid || "";
    const submitted = location.state?.submitted || "";
    useEffect(() => {
        if (
            cusdectext.trim() !== "" &&
            cusdectext !== lastProcessedValueRef.current &&
            !isProcessingRef.current
        ) {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }

            timeoutRef.current = setTimeout(() => {
                isProcessingRef.current = true;
                lastProcessedValueRef.current = cusdectext;
                const searchType = activeScannerRef.current === "BID" ? "bid"
                         : activeScannerRef.current === "ISBN" ? "isbn"
                         : null;
                cusSearch(searchType, true).finally(() => {
                    isProcessingRef.current = false;
                    setActiveScanner(null);
                    setDecodedResults([]);
                    setCusDecText("");
                });
            }, 300);
        }

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [cusdectext]);
    useEffect(() => {
        return () => {
            Modal.destroyAll();
        };
    }, []);
    useEffect(() => {
        const loadRegexPatterns = async () => {
            try {
                await validationService.fetchRegexData(accessToken);
            } catch (error) {
                console.error("Failed to load regex patterns:", error);
            }
        };

        if (accessToken) {
            loadRegexPatterns();
        }
    }, [accessToken]);

    const onNewScanResult = (decodedText, decodedResult) => {
        if (
            decodedText === lastProcessedValueRef.current ||
            isProcessingRef.current
        ) {
            return;
        }

        setDecodedResults((prev) => {
            if (prev.includes(decodedText)) {
                return prev;
            }
            return [...prev, decodedText];
        });

        setCusDecText(decodedText);
        if (activeScannerRef.current === "BID") {
          setForm({ ...form, bid: decodedText, isbn: "" });
        } else if (activeScannerRef.current === "ISBN") {
          setForm({ ...form, bid: "", isbn: decodedText });
        }
    };

    const handleDrawerVisible = (e) => {
        e.preventDefault();
        setIsDisabled(true);
        setTimeout(() => {
            setIsDisabled(false);
        }, 2000);
        if (!data || data.length === 0) {
            message.error(
                "Please add at least one item to the table before proceeding",
            );
            return;
        }
        setDrawerVisible(true);
    };
    const [activeScanner, setActiveScanner] = useState(null);
    const [decodedResults, setDecodedResults] = useState([]);

    useEffect(() => {
       activeScannerRef.current = activeScanner;
    }, [activeScanner]);

  useEffect(() => {
        fetchExceptionActionStatuses();
    }, []);

    useEffect(() => {
        const savedData = localStorage.getItem('exception_records');
        if (savedData) {
            setData(JSON.parse(savedData));

        }
        if (submitted && bid) {
            setData((prev) => prev.filter((item) => item.bid !== bid));
        }
        if (location?.state) {
            navigate(location.pathname, { replace: true, state: {} });
        }

        localStorage.removeItem('exception_records');
        console.log("isbnkey", isbnkey)
    }, []);

    const handleEdit = (key, string) => {
        localStorage.setItem('exception_records', JSON.stringify(data));
        navigate("/self-fixed", { state: { key, string } });
    };

  const handleClear = () => {
    if (data.length > 0) {
      ConfirmationModal.showClearConfirmation(() => {
          setData([]);
          setErrors({});
      });
    }
  };
  const columns = [
    {
      title: "BID",
      dataIndex: "bid",
      key: "bid",
      width: 200,
    },
    {
      title: "ISBN",
      dataIndex: "isbn",
      key: "isbn",
      width: 200,
    },
    {
      title: "Rack Shelf",
      dataIndex: "rackAndShelf",
      key: "rackAndShelf",
      width: 200,
    },
    {
      title: "Status",
      dataIndex: "statusName",
      key: "statusName",
      width: 200,
      render: (text) => <span className="status-badge"> {text} </span>,
    },
    {
        title: "Reject Reason",
        dataIndex: "rejectReason",
        key: "rejectReason",
        width: 200,
    },
    {
      title: "Action",
      dataIndex: "rackNo",
      key: "rackNo",
      width: 200,
        render: (text, record) => (
      <div >
        <Button
          type="link"
          size="small"
          onClick={() => handleRemoveRow(record)}
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_5103_15927)">
              <circle
                opacity="0.5"
                cx="9"
                cy="9"
                r="7.5"
                stroke="#1C274C"
                stroke-width="1.125"
              />
              <path
                d="M11.25 9H6.75"
                stroke="#1C274C"
                stroke-width="1.125"
                stroke-linecap="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_5103_15927">
                <rect width="18" height="18" fill="white" />
              </clipPath>
            </defs>
          </svg>
          </Button>
                {(record.statusName !== "Manifest Reject" && record.statusName !== "Unauthorized") && (
                    <Space size="middle" title="Recover">
                        <button type="button" data-track="ExceptionBookAction-open-recover-slide" onClick={() => {
                            handleRecoverSlideVisible(record);
                        }
                        }>
                            <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_5244_39974)">
                                    <path d="M5.53317 8.72222H4.93317V8.72222L5.53317 8.72222ZM5.53317 9.41667L5.08399 9.81445C5.19222 9.93667 5.34557 10.0095 5.50868 10.0162C5.6718 10.0228 5.83058 9.96274 5.94842 9.84976L5.53317 9.41667ZM7.16524 8.6831C7.40444 8.45376 7.41243 8.07395 7.1831 7.83476C6.95376 7.59556 6.57395 7.58757 6.33476 7.8169L6.75 8.25L7.16524 8.6831ZM4.94918 7.85221C4.72949 7.60414 4.35029 7.58113 4.10221 7.80082C3.85414 8.02051 3.83113 8.39971 4.05082 8.64779L4.5 8.25L4.94918 7.85221ZM11.1712 6.78244C11.3963 7.02569 11.7759 7.04047 12.0191 6.81544C12.2624 6.59042 12.2771 6.21081 12.0521 5.96756L11.6117 6.375L11.1712 6.78244ZM9.03278 5.25V4.65C6.77308 4.65 4.93317 6.46876 4.93317 8.72222H5.53317H6.13317C6.13317 7.14037 7.42692 5.85 9.03278 5.85V5.25ZM5.53317 8.72222L4.93317 8.72222L4.93317 9.41667H5.53317H6.13317L6.13317 8.72222L5.53317 8.72222ZM5.53317 9.41667L5.94842 9.84976L7.16524 8.6831L6.75 8.25L6.33476 7.8169L5.11793 8.98357L5.53317 9.41667ZM5.53317 9.41667L5.98236 9.01888L4.94918 7.85221L4.5 8.25L4.05082 8.64779L5.08399 9.81445L5.53317 9.41667ZM11.6117 6.375L12.0521 5.96756C11.3031 5.15782 10.2267 4.65 9.03278 4.65V5.25V5.85C9.88006 5.85 10.6409 6.20913 11.1712 6.78244L11.6117 6.375Z" fill="#002449" />
                                    <path d="M12.4641 8.58301L12.9126 8.18451C12.8043 8.06252 12.6509 7.98994 12.4878 7.98348C12.3248 7.97702 12.1662 8.03724 12.0485 8.15026L12.4641 8.58301ZM10.8344 9.31628C10.5954 9.54581 10.5877 9.92564 10.8173 10.1646C11.0468 10.4036 11.4266 10.4113 11.6656 10.1818L11.25 9.74902L10.8344 9.31628ZM13.0515 10.1475C13.2715 10.3953 13.6508 10.4177 13.8985 10.1976C14.1462 9.97749 14.1686 9.59825 13.9485 9.35052L13.5 9.74902L13.0515 10.1475ZM6.8125 11.2276C6.58574 10.986 6.20603 10.974 5.9644 11.2007C5.72278 11.4275 5.71073 11.8072 5.9375 12.0488L6.375 11.6382L6.8125 11.2276ZM8.9511 12.7497V13.3497C11.216 13.3497 13.0641 11.5331 13.0641 9.27745H12.4641H11.8641C11.8641 10.8572 10.5665 12.1497 8.9511 12.1497V12.7497ZM12.4641 9.27745H13.0641V8.58301H12.4641H11.8641V9.27745H12.4641ZM12.4641 8.58301L12.0485 8.15026L10.8344 9.31628L11.25 9.74902L11.6656 10.1818L12.8797 9.01575L12.4641 8.58301ZM12.4641 8.58301L12.0155 8.98151L13.0515 10.1475L13.5 9.74902L13.9485 9.35052L12.9126 8.18451L12.4641 8.58301ZM6.375 11.6382L5.9375 12.0488C6.68857 12.8491 7.76191 13.3497 8.9511 13.3497V12.7497V12.1497C8.10468 12.1497 7.3446 11.7946 6.8125 11.2276L6.375 11.6382Z" fill="#002449" />
                                    <circle opacity="0.5" cx="9" cy="9" r="7.5" stroke="#002449" stroke-width="1.2" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_5244_39974">
                                        <rect width="18" height="18" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>

                            </button>

                        </Space>)}
                    {record.statusName === "Client Review - Reject" && (
				<Space size="middle" style={{marginLeft:"5px"}}  title="Self Fix">
          <button type="button" data-track="ExceptionBookAction-open-self-fix" onClick={() => handleEdit(record.bid, 'exception')}>
                    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="9" cy="4.5" r="3" stroke="#002449" stroke-width="1.2"/>
                    <path opacity="0.5" d="M11.25 9.99533C10.5552 9.83712 9.79568 9.75 9 9.75C5.68629 9.75 3 11.261 3 13.125C3 14.989 3 16.5 9 16.5C13.2656 16.5 14.4986 15.7363 14.8551 14.625" stroke="#002449" stroke-width="1.2"/>
                    <rect x="9" y="9" width="8.25" height="8.25" rx="4.125" fill="white"/>
                    <g clip-path="url(#clip0_5244_39975)">
                    <circle cx="14" cy="13" r="1" stroke="#002449"/>
                    <path d="M14.5867 9.71774C14.4641 9.66699 14.3088 9.66699 13.9982 9.66699C13.6876 9.66699 13.5323 9.66699 13.4098 9.71774C13.2464 9.7854 13.1166 9.91518 13.049 10.0785C13.0181 10.1531 13.006 10.2398 13.0012 10.3663C12.9943 10.5522 12.899 10.7243 12.7379 10.8173C12.5768 10.9103 12.3801 10.9068 12.2156 10.8199C12.1037 10.7608 12.0225 10.7279 11.9425 10.7173C11.7672 10.6943 11.5899 10.7418 11.4497 10.8494C11.3445 10.9301 11.2668 11.0646 11.1115 11.3336C10.9562 11.6026 10.8785 11.7372 10.8612 11.8686C10.8381 12.0439 10.8856 12.2212 10.9933 12.3615C11.0424 12.4255 11.1114 12.4793 11.2186 12.5467C11.3761 12.6457 11.4775 12.8143 11.4775 13.0003C11.4775 13.1864 11.3761 13.355 11.2186 13.4539C11.1114 13.5213 11.0424 13.5751 10.9932 13.6391C10.8856 13.7794 10.8381 13.9567 10.8612 14.132C10.8785 14.2635 10.9561 14.398 11.1115 14.667C11.2668 14.936 11.3444 15.0705 11.4496 15.1512C11.5899 15.2589 11.7672 15.3064 11.9425 15.2833C12.0225 15.2728 12.1036 15.2399 12.2156 15.1807C12.38 15.0938 12.5767 15.0903 12.7378 15.1833C12.899 15.2764 12.9943 15.4484 13.0012 15.6343C13.006 15.7608 13.0181 15.8475 13.049 15.9221C13.1166 16.0855 13.2464 16.2152 13.4098 16.2829C13.5323 16.3337 13.6876 16.3337 13.9982 16.3337C14.3088 16.3337 14.4641 16.3337 14.5867 16.2829C14.75 16.2152 14.8798 16.0855 14.9475 15.9221C14.9783 15.8475 14.9904 15.7608 14.9952 15.6343C15.0021 15.4484 15.0974 15.2764 15.2585 15.1833C15.4196 15.0903 15.6164 15.0938 15.7808 15.1807C15.8927 15.2399 15.9739 15.2727 16.0539 15.2833C16.2292 15.3064 16.4065 15.2588 16.5467 15.1512C16.652 15.0705 16.7296 14.936 16.8849 14.667C17.0402 14.398 17.1179 14.2635 17.1352 14.132C17.1583 13.9567 17.1108 13.7794 17.0031 13.6391C16.954 13.5751 16.885 13.5213 16.7778 13.4539C16.6203 13.3549 16.5189 13.1863 16.5189 13.0003C16.5189 12.8143 16.6203 12.6457 16.7778 12.5467C16.885 12.4794 16.954 12.4255 17.0032 12.3615C17.1108 12.2212 17.1583 12.0439 17.1352 11.8686C17.1179 11.7372 17.0403 11.6027 16.885 11.3337C16.7296 11.0646 16.652 10.9301 16.5468 10.8494C16.4065 10.7418 16.2292 10.6943 16.0539 10.7174C15.9739 10.7279 15.8928 10.7608 15.7809 10.8199C15.6164 10.9069 15.4197 10.9103 15.2586 10.8173C15.0975 10.7243 15.0021 10.5522 14.9952 10.3663C14.9904 10.2398 14.9783 10.1531 14.9475 10.0785C14.8798 9.91518 14.75 9.7854 14.5867 9.71774Z" stroke="#002449"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_5244_39975">
                    <rect x="10" y="9" width="8" height="8" rx="4" fill="white"/>
                    </clipPath>
                    </defs>
                    </svg>

                            </button>

                        </Space>)}
                </div>

            ),
        },
    ];

    const getRowClassName = (record, index) => {
        return index % 2 === 0 ? "odd-row" : "even-row";
    };
    const handleTableChange = (newPagination, filters, sorter) => {
        const normalizeFilters = {};
        Object.keys(filters).forEach((key) => {
            if (filters[key] && filters[key].length > 0) {
                normalizeFilters[key] = filters[key][0];
            }
        });

        fetchData();
    };

    const fetchData = async () => {
        const bidValue = form?.bid?.trim() || "";
        if (bidValue.length > 0) {
            const payload = {
                RackNos: bidValue,
                UserId: 2,
            };

            try {
                const myHeaders = {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accessToken}`,
                    "X-CSRF-Token": encryptTimestamp(),
                };
                const response = await fetch(CommonObj.Endpoints.GetBooksByRackNo, {
                    method: "POST",
                    headers: myHeaders,
                    body: JSON.stringify(payload),
                });

                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                const data = await response.json();
                console.log("resulserach???", data);
                if (data?.error === "No Ready to Recycle Details found") {
                    setData([]);
                    message.warning("The scanned Rack ID is not exist");
                } else {
                    setData(data);
                }
            } catch (err) {
                console.error("Fetch Data Error:", err);
            } finally {
            }
        } else {
            setData([]);
        }
    };

    if (loading) {
        return (
            <Spin size="large" style={{ margin: "20px auto" }} />
        );
    }

    const cusSearch = async (searchType, isScannerFlow = false) => {
        if (searchType === "bid" && isReadOnly("bid") && !isScannerFlow) {
            showManualEntryDisabledWarning();
            return;
        }
        if (searchType === "isbn" && isReadOnly("isbn") && !isScannerFlow) {
            showManualEntryDisabledWarning();
            return;
        }

        setIsDisabled(true);
        setTimeout(() => {
            setIsDisabled(false);
        }, 2000);

        let searchValue = searchType === "bid" ? form.bid.trim() : form.isbn.trim();

        let bidValue = form?.bid?.trim();

        const bidError = validationService.validateBid(form?.bid);
        if (searchType === "bid" && bidError) {
            message.error(bidError);
            setForm({ ...form, bid: "" });
            return;
        }

        const isbnResult = validationService.validateISBN(form?.isbn);
        if (searchType === "isbn" && !isbnResult.isValid) {
            message.error(isbnResult.error);
            setForm({ ...form, isbn: "" });
            return;
        }


        try {
            const myHeaders = {
                Authorization: `Bearer ${accessToken}`,
                "X-CSRF-Token": encryptTimestamp(),
                "Content-Type": "application/json",
            };

            const payload = JSON.stringify(
                searchType === "bid"
                    ? { field: "BID", value: bidValue }
                    : { field: "ISBN", value: searchValue },
            );

            const response = await fetch(
                CommonObj.Endpoints.GetExceptionActionByBID,
                {
                    method: "POST",
                    headers: myHeaders,
                    body: payload,
                },
            );

            if (!response.ok) {
                throw new Error("Network response was not ok");
            }

            const apiResp = await response.json();
              if (
                !apiResp.books ||
                apiResp.books.length === 0 ||
                (apiResp.books[0]?.bid === null || apiResp.books[0]?.isbn === null)
              ) {
                        message.warning(apiResp.message || "No data found for this BID");
                setForm((prev) => ({
                  ...prev,
                  [searchType]: "",
                }));
                return;
            }

            const existingBids = data.map((item) => `${item.bid}-${item.isbn}`);
            const incomingBids = apiResp.books.map(
                (item) => `${item.bid}-${item.isbn}`,
            );

            const duplicateBids = incomingBids.filter((bid) =>
                existingBids.includes(bid),
            );

            if (duplicateBids.length > 0) {
                message.warning(
                    form.bid
                        ? `BID already exist in the grid`
                        : `ISBN already exist in the grid`,
                );
                setForm({ ...form, [searchType]: "" });
                return;
            }

            setData((prev) => [...prev, ...apiResp.books]);
            setForm({ ...form, bid: "", isbn: "" });
        } catch (err) {
            console.error("Fetch Data Error:", err);
            message.error("Failed to fetch book details. Please try again.");
              setForm((prev) => ({
                ...prev,
                [searchType]: "",
              }));
        } finally {
        }
    };

    const handleSearchClick = () => {
        if (
            !isProcessingRef.current &&
            form.bid.trim() !== "" &&
            form.isbn.trim() !== ""
        ) {
            cusSearch();
        }
    };
    const fetchExceptionActionStatuses = async () => {
        try {
            const response = await fetch(`${CommonObj.Endpoints.GetExceptionActionStatus}?isMRBQISBN=${false}`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "X-CSRF-Token": encryptTimestamp(),
                        "Content-Type": "application/json",
                    },
                },
            );

            if (!response.ok) {
                throw new Error("Failed to fetch action statuses");
            }

            const data = await response.json();
            setExceptionActionStatuses(data);
        } catch (error) {
            console.error("Error:", error.message);
            message.error("Unable to fetch action statuses.");
        }
    };
    const fetchMoveToStationValues = async (status) => {
        try {
            const formData = new FormData();
            formData.append('statusName', status);
            const response = await fetch(
                `${configJson.baseUrl}/api/ExceptionAction/GetRecoveryProcess`,
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "X-CSRF-Token": encryptTimestamp(),
                    },
                    body: formData
                },
            );

            if (!response.ok) {
                throw new Error("Failed to fetch move to station statuses");
            }

            const result = await response.json();
            const data = Array.isArray(result) ? result : [result];
            setMoveToStationValues(data);
        } catch (error) {
            console.error("Error:", error.message);
            message.error("Unable to fetch move to station statuses.");
        }
    };
    const handleActionSelect = (action) => {
        setSelectedAction(action);
    };
    const handleRemoveRow = (records) => {
        if (records.statusName === "Unauthorized")
            setData((prev) => prev.filter((item) => item.isbn !== records.isbn));
        else
            setData((prev) => prev.filter((item) => item.bid !== records.bid));
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsDisabled(true);
        setTimeout(() => {
            setIsDisabled(false);
        }, 2000);
        if (selectedAction) {
            const payload = {
                input: data.map((item) => ({
                    isbn: item.isbn,
                    bid: item.bid,
                })),
                status: selectedAction,
                createdBy: roleUserId,
            };
            setLoading(true);

            try {
                const response = await fetch(
                    `${configJson.baseUrl}/api/Intake/ExceptionActionSubmit`,
                    {
                        method: "POST",
                        headers: {
                            Authorization: `Bearer ${accessToken}`,
                            "Content-Type": "application/json",
                            "X-CSRF-Token": encryptTimestamp(),
                        },
                        body: JSON.stringify(payload),
                    },
                );

                if (!response.ok) {
                    throw new Error("Error submitting action status");
                }

                message.success("Action status submitted successfully");
                setDrawerVisible(false);
                setForm({ bid: "", isbn: "" });
                setSelectedAction(null);
                setData([]);
            } catch (error) {
                console.error("Error:", error.message);
                message.error("Failed to submit action status.");
            } finally {
                setLoading(false);
            }
        } else {
            message.warning("Please select an action before submitting.");
        }
    };

    const menuItems = [
        {
            label: "My Profile",
            key: "profile",
            icon: (
                <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clip-path="url(#clip0_5103_15927)">
                        <circle
                            opacity="0.5"
                            cx="9"
                            cy="9"
                            r="7.5"
                            stroke="#1C274C"
                            stroke-width="1.125"
                        />
                        <path
                            d="M11.25 9H6.75"
                            stroke="#1C274C"
                            stroke-width="1.125"
                            stroke-linecap="round"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_5103_15927">
                            <rect width="18" height="18" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            ),
        },
    ];
    const clearForm = () => {
        setData((prev) => prev?.filter((item) => item.bid !== recoverData?.bid));
        setRecoverdata({})
    }
    const handleRecoverSlideVisible = async(e) => {
        await fetchMoveToStationValues(e?.statusName);
        recoverSubmissionData(e);
        setShowRecoverModal(true);
    };
    const recoverSubmissionData = (record) => {
        const submissionData = {
            isbn: record.isbn,
            bid: record.bid,
            createdBy: roleUserId,
            rackAndShelf: record.rackAndShelf,
        };
        setRecoverdata(submissionData);
    }
  return (
      <>
          <RecoverSlide
              isModalVisible={showRecoverModal}
              setIsModalVisible={setShowRecoverModal}
              clearForm={clearForm}
              title={"Exception Books Action"}
              recoverSubmissionData={recoverData}
              oldRackandShelf={recoverData?.rackAndShelf}
              moveToStatusValue={moveToStationValues}
              exceptionActionStatuses={exceptionActionStatuses}
              onScannerOpen={(scanner) => { setActiveScanner(scanner) }}
              emptyDecode={() => { setDecodedResults([]) }}
              className="story-slider slider-with-footer"
              width={540}
          />
      <Drawer
        className="story-slider"
        title="Exception Books Action"
        placement="right"
        onClose={() =>{ 
            setDrawerVisible(false);
            setSelectedAction(null);
        }}
        open={drawerVisible}
        width={400}
        footer={
          <div
            className="exception book-page-action-container"
            style={{ justifyContent: "end" }}
          >
            <div style={{ textAlign: "right" }}>
              <div className="book-page-buttons-container justify-space">
                <button
                  type="button"
                  className="download-button-outline-manifest"
                  onClick={() => {
                    setSelectedAction(null);
                    handleActionSelect(null);
                  }}
                  style={{ marginRight: 8 }}
                >
                  <span></span>
                  <span>Clear</span>
                </button>
                <button
                  className="accept-button"
                  data-track="Exception-action-submit"
                  disabled={isDisabled}
                  onClick={handleSubmit}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        }
          >
        <div>
          <Select
            style={{
              width: "100%",
              border: "1px solid #d9d9d9",
              borderRadius: "6px",
            }}
            onChange={handleActionSelect}
            optionLabelProp="label"
            placeholder
            value={selectedAction}
          >
            <Option
              disabled
              label={
                <span>
                  Select Action <span style={{ color: "red" }}>*</span>
                </span>
              }
            >
              <span style={{ display: "flex", alignItems: "center" }}>
                <span style={{ marginLeft: 8 }}>
                  Select Action <span style={{ color: "red" }}>*</span>
                </span>
              </span>
            </Option>
            {exceptionActionStatuses.map((status) => (
              <Option
                key={status.statusID}
                value={status.statusID}
                label={status.statusName}
              >
                <span style={{ display: "flex", alignItems: "center" }}>
                  {status.statusID === selectedAction ? (
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2Z"
                        fill="white"
                      />
                      <path
                        d="M8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2Z"
                        stroke="url(#paint0_linear_5157_22877)"
                        stroke-width="4"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_5157_22877"
                          x1="16.48"
                          y1="7.9558"
                          x2="-0.0557203"
                          y2="9.67356"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#033D9B" />
                          <stop offset="1" stop-color="#29ACD5" />
                        </linearGradient>
                      </defs>
                    </svg>
                  ) : (
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8 0.5C12.1421 0.5 15.5 3.85786 15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5Z"
                        fill="white"
                      />
                      <path
                        d="M8 0.5C12.1421 0.5 15.5 3.85786 15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5Z"
                        stroke="#CCDAE4"
                      />
                    </svg>
                  )}
                  <span style={{ marginLeft: 8 }}>{status.statusName}</span>
                </span>
              </Option>
            ))}
          </Select>
        </div>
      </Drawer>

            <Modal
                title={`Scan ${activeScanner ? activeScanner : ""}`}
                open={!!activeScanner}
                onCancel={() => {
                    setActiveScanner(null);
                    isProcessingRef.current = false;
                }}
                footer={null}
                destroyOnClose
                className="scan-model-container"
                width={1000}
            >
                <div className="scan-modal">
                    <Html5QrcodePlugin
                        fps={30}
                        qrbox={{ width: 1000, height: 400 }}
                        aspectRatio={2.8}
                        disableFlip={false}
                        qrCodeSuccessCallback={onNewScanResult}
                        supportedScanTypes={[Html5QrcodeScanType.SCAN_TYPE_CAMERA]}
                    />
                </div>
            </Modal>
            <main className="book-page-main-container">
                <div className="book-page-container">
                    <div className="book-page-title-container no-padding-right">
                        <div className="book-page-title">
                            <span>
                                <img
                                    src={ManifestCreation1Icon}
                                    alt="Manifest Creation icon"
                                ></img>
                            </span>
                            <h2>Exception Book Action</h2>
                        </div>
                    </div>
                    <div className="book-page-form exception-form">
                        <div className="book-page-camera-button-container multiple w-100">
                            <Input
                                placeholder=""
                                value={form.bid}
                                className={`${form.bid ? "has-id" : ""}`}
                                onChange={(e) => {
                                    setForm({ ...form, bid: e.target.value });
                                }}
                                onKeyDown={(e) => {
                                    if (!isReadOnly("bid")) {
                                        return;
                                    }

                                    // Let native copy/paste behave normally (no custom clipboard handling).
                                    const isCopyOrPasteShortcut =
                                        (e.ctrlKey || e.metaKey) && ["c", "v", "C", "V"].includes(e.key);
                                    if (isCopyOrPasteShortcut) {
                                        return;
                                    }

                                    if (e.key === 'Enter' || e.key === 'Tab') {
                                        return;
                                    }

                                    const currentTime = Date.now();
                                    const timeDiff = currentTime - lastBidKeyTimeRef.current;
                                    lastBidKeyTimeRef.current = currentTime;

                                    // A physical scanner sends characters within a few milliseconds of each
                                    // other, so only block keystrokes that arrive slowly (manual typing).
                                    // The very first keystroke (field currently empty) is always let through
                                    // so a scan burst never loses its first character.
                                    const isSlowManualKeystroke = timeDiff > 50 && e.currentTarget.value.length > 0;
                                    if (!isSlowManualKeystroke) {
                                        return;
                                    }

                                    e.preventDefault();
                                    setForm((prev) => ({ ...prev, bid: '' }));

                                    clearTimeout(clearBidTimerRef.current);
                                    clearBidTimerRef.current = setTimeout(() => {
                                        showManualEntryDisabledWarning();
                                    }, 300);
                                }}
                                onPressEnter={(e) => {
                                    if (isReadOnly("bid")) {
                                        e.preventDefault();
                                        return;
                                    }
                                    cusSearch("bid");
                                }}

                                disabled={isDisabled}
                            />
                            {form.bid.length === 0 && (
                                <label htmlFor="cutting-batch-bid-input-id">
                                    {isReadOnly("bid") ? "Scan " : "Enter / Scan "}Book ID (BID) Number Using “
                                    <strong>Camera Icon</strong>”
                                    <span className="form-required">*</span>
                                </label>
                            )}
                            <button
                                type="button"
                                className="book-page-camera-button"
                                 data-track="ExceptionBookAction-open-bid-scanner"
                                onClick={() => setActiveScanner("BID")}
                            >
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle
                                        cx="12"
                                        cy="13"
                                        r="3"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                    />
                                    <path
                                        opacity="0.5"
                                        d="M10 19.9999H14C16.8089 19.9999 18.2134 19.9999 19.2223 19.3258C19.659 19.0339 20.034 18.6589 20.3259 18.2222C21 17.2133 21 15.8088 21 12.9999C21 10.191 20.9999 8.78673 20.3257 7.77783C20.0339 7.34107 19.6589 6.96607 19.2221 6.67423C18.2132 6.00011 16.8088 6.00011 13.9999 6.00011H9.99985C7.19093 6.00011 5.78646 6.00011 4.77757 6.67423C4.34081 6.96607 3.96581 7.34107 3.67397 7.77783C3 8.7865 3 10.1903 3 12.998L3 12.9999C3 15.8088 3 17.2133 3.67412 18.2222C3.96596 18.6589 4.34096 19.0339 4.77772 19.3258C5.78661 19.9999 7.19108 19.9999 10 19.9999Z"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                    />
                                    <path
                                        d="M18 10H17.5"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                    />
                                    <path
                                        opacity="0.5"
                                        d="M14.5 3.5H9.5"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                    />
                                </svg>
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M8.00098 4C8.00098 3.44772 8.41425 3 8.92405 3H15.0779C15.5877 3 16.001 3.44772 16.001 4C16.001 4.55228 15.5877 5 15.0779 5H8.92405C8.41425 5 8.00098 4.55228 8.00098 4Z"
                                        fill="url(#paint0_linear_273_6917)"
                                    />
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M9.77875 21H14.2232C17.3442 21 18.9047 21 20.0257 20.2777C20.511 19.965 20.9277 19.5632 21.252 19.0953C22.001 18.0143 22.001 16.5095 22.001 13.4999C22.001 10.4903 22.0008 8.9857 21.2518 7.90473C20.9275 7.43676 20.5109 7.03497 20.0256 6.72228C18.9046 6 17.3441 6 14.223 6H9.77859C6.65756 6 5.09705 6 3.97605 6.72228C3.49077 7.03497 3.0741 7.43676 2.74984 7.90473C2.00098 8.98547 2.00098 10.4896 2.00098 13.4979L2.00098 13.4999C2.00098 16.5095 2.00098 18.0143 2.75 19.0953C3.07426 19.5632 3.49093 19.965 3.97622 20.2777C5.09721 21 6.65773 21 9.77875 21ZM7.83431 13.4999C7.83431 11.2808 9.69979 9.48196 12.001 9.48196C14.3022 9.48196 16.1676 11.2808 16.1676 13.4999C16.1676 15.7189 14.3022 17.5178 12.001 17.5178C9.69979 17.5178 7.83431 15.7189 7.83431 13.4999ZM9.50098 13.4999C9.50098 12.1685 10.6203 11.0891 12.001 11.0891C13.3817 11.0891 14.501 12.1685 14.501 13.4999C14.501 14.8313 13.3817 15.9106 12.001 15.9106C10.6203 15.9106 9.50098 14.8313 9.50098 13.4999ZM18.1121 9.48196C17.6519 9.48196 17.2788 9.84174 17.2788 10.2855C17.2788 10.7294 17.6519 11.0891 18.1121 11.0891H18.6676C19.1279 11.0891 19.501 10.7294 19.501 10.2855C19.501 9.84174 19.1279 9.48196 18.6676 9.48196H18.1121Z"
                                        fill="url(#paint1_linear_273_6917)"
                                    />
                                    <defs>
                                        <linearGradient
                                            id="paint0_linear_273_6917"
                                            x1="22.601"
                                            y1="11.9503"
                                            x2="1.98296"
                                            y2="14.3301"
                                            gradientUnits="userSpaceOnUse"
                                        >
                                            <stop stopColor="#033D9B" />
                                            <stop offset="1" stopColor="#29ACD5" />
                                        </linearGradient>
                                        <linearGradient
                                            id="paint1_linear_273_6917"
                                            x1="22.601"
                                            y1="11.9503"
                                            x2="1.98296"
                                            y2="14.3301"
                                            gradientUnits="userSpaceOnUse"
                                        >
                                            <stop stopColor="#033D9B" />
                                            <stop offset="1" stopColor="#29ACD5" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </button>
                            <button
                                type="button"
                              className="book-page-camera-button-input-2"
                              data-track="ExceptionBookAction-search-bid"
                                onClick={() => cusSearch("bid", true)}
                                disabled={isDisabled}
                            >
                                <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM11.0303 6.46967C10.7374 6.17678 10.2626 6.17678 9.96967 6.46967C9.67678 6.76256 9.67678 7.23744 9.96967 7.53033L12.4393 10L9.96967 12.4697C9.67678 12.7626 9.67678 13.2374 9.96967 13.5303C10.2626 13.8232 10.7374 13.8232 11.0303 13.5303L14.0303 10.5303C14.3232 10.2374 14.3232 9.76256 14.0303 9.46967L11.0303 6.46967ZM5.96967 6.46967C6.26256 6.17678 6.73744 6.17678 7.03033 6.46967L10.0303 9.46967C10.3232 9.76256 10.3232 10.2374 10.0303 10.5303L7.03033 13.5303C6.73744 13.8232 6.26256 13.8232 5.96967 13.5303C5.67678 13.2374 5.67678 12.7626 5.96967 12.4697L8.43934 10L5.96967 7.53033C5.67678 7.23744 5.67678 6.76256 5.96967 6.46967Z"
                                        fill="url(#paint0_linear_1900_8687)"
                                    />
                                    <defs>
                                        <linearGradient
                                            id="paint0_linear_1900_8687"
                                            x1="20.6"
                                            y1="9.94475"
                                            x2="-0.0696504"
                                            y2="12.0919"
                                            gradientUnits="userSpaceOnUse"
                                        >
                                            <stop stopColor="#033D9B" />
                                            <stop offset="1" stopColor="#29ACD5" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </button>
                        </div>
                        <div className="book-page-camera-button-container multiple w-100">
                            <Input
                                placeholder=""
                                value={form.isbn}
                                className={`${form.isbn ? "has-id" : ""}`}
                                onChange={(e) => {
                                    setForm({ ...form, isbn: e.target.value });
                                }}
                                onKeyDown={(e) => {
                                    if (!isReadOnly("isbn")) {
                                        return;
                                    }

                                    // Let native copy/paste behave normally (no custom clipboard handling).
                                    const isCopyOrPasteShortcut =
                                        (e.ctrlKey || e.metaKey) && ["c", "v", "C", "V"].includes(e.key);
                                    if (isCopyOrPasteShortcut) {
                                        return;
                                    }

                                    if (e.key === 'Enter' || e.key === 'Tab') {
                                        return;
                                    }

                                    const currentTime = Date.now();
                                    const timeDiff = currentTime - lastIsbnKeyTimeRef.current;
                                    lastIsbnKeyTimeRef.current = currentTime;

                                    // A physical scanner sends characters within a few milliseconds of each
                                    // other, so only block keystrokes that arrive slowly (manual typing).
                                    // The very first keystroke (field currently empty) is always let through
                                    // so a scan burst never loses its first character.
                                    const isSlowManualKeystroke = timeDiff > 50 && e.currentTarget.value.length > 0;
                                    if (!isSlowManualKeystroke) {
                                        return;
                                    }

                                    e.preventDefault();
                                    setForm((prev) => ({ ...prev, isbn: '' }));

                                    clearTimeout(clearIsbnTimerRef.current);
                                    clearIsbnTimerRef.current = setTimeout(() => {
                                        showManualEntryDisabledWarning();
                                    }, 300);
                                }}
                                onPressEnter={(e) => {
                                    if (isReadOnly("isbn")) {
                                        e.preventDefault();
                                        return;
                                    }
                                    cusSearch("isbn");
                                }}
                                disabled={isDisabled}
                            />
                            {form.isbn.length === 0 && (
                                <label htmlFor="cutting-batch-bid-input-id">
                                    {isReadOnly("isbn") ? "Scan " : "Enter / Scan "}ISBN Number Using “
                                    <strong>Camera Icon</strong>”
                                    <span className="form-required">*</span>
                                </label>
                            )}
                            <button
                                type="button"
                                className="book-page-camera-button"
                                data-track="ExceptionBookAction-open-isbn-scanner"
                                onClick={() => setActiveScanner("ISBN")}
                            >
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle
                                        cx="12"
                                        cy="13"
                                        r="3"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                    />
                                    <path
                                        opacity="0.5"
                                        d="M10 19.9999H14C16.8089 19.9999 18.2134 19.9999 19.2223 19.3258C19.659 19.0339 20.034 18.6589 20.3259 18.2222C21 17.2133 21 15.8088 21 12.9999C21 10.191 20.9999 8.78673 20.3257 7.77783C20.0339 7.34107 19.6589 6.96607 19.2221 6.67423C18.2132 6.00011 16.8088 6.00011 13.9999 6.00011H9.99985C7.19093 6.00011 5.78646 6.00011 4.77757 6.67423C4.34081 6.96607 3.96581 7.34107 3.67397 7.77783C3 8.7865 3 10.1903 3 12.998L3 12.9999C3 15.8088 3 17.2133 3.67412 18.2222C3.96596 18.6589 4.34096 19.0339 4.77772 19.3258C5.78661 19.9999 7.19108 19.9999 10 19.9999Z"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                    />
                                    <path
                                        d="M18 10H17.5"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                    />
                                    <path
                                        opacity="0.5"
                                        d="M14.5 3.5H9.5"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                    />
                                </svg>
                                <svg
                                    width="20"
                                    height="18"
                                    viewBox="0 0 20 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M6 1C6 0.447715 6.41328 0 6.92308 0H13.0769C13.5867 0 14 0.447715 14 1C14 1.55228 13.5867 2 13.0769 2H6.92308C6.41328 2 6 1.55228 6 1Z"
                                        fill="url(#paint0_linear_273_6915)"
                                    />
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M7.77778 18H12.2222C15.3433 18 16.9038 18 18.0248 17.2777C18.51 16.965 18.9267 16.5632 19.251 16.0953C20 15.0143 20 13.5095 20 10.4999C20 7.49027 19.9998 5.9857 19.2508 4.90473C18.9266 4.43676 18.5099 4.03497 18.0246 3.72228C16.9036 3 15.3431 3 12.2221 3H7.77761C4.65659 3 3.09607 3 1.97508 3.72228C1.48979 4.03497 1.07312 4.43676 0.748859 4.90473C-5.96046e-08 5.98547 -3.64038e-08 7.48961 0 10.4979L0 10.4999C0 13.5095 5.96046e-08 15.0143 0.749024 16.0953C1.07328 16.5632 1.48995 16.965 1.97524 17.2777C3.09624 18 4.65675 18 7.77778 18ZM5.83333 10.4999C5.83333 8.28085 7.69881 6.48196 10 6.48196C12.3012 6.48196 14.1667 8.28085 14.1667 10.4999C14.1667 12.7189 12.3012 14.5178 10 14.5178C7.69881 14.5178 5.83333 12.7189 5.83333 10.4999ZM7.5 10.4999C7.5 9.16846 8.61929 8.08913 10 8.08913C11.3807 8.08913 12.5 9.16846 12.5 10.4999C12.5 11.8313 11.3807 12.9106 10 12.9106C8.61929 12.9106 7.5 11.8313 7.5 10.4999ZM16.1111 6.48196C15.6509 6.48196 15.2778 6.84174 15.2778 7.28554C15.2778 7.72935 15.6509 8.08913 16.1111 8.08913H16.6667C17.1269 8.08913 17.5 7.72935 17.5 7.28554C17.5 6.84174 17.1269 6.48196 16.6667 6.48196H16.1111Z"
                                        fill="url(#paint1_linear_273_6915)"
                                    />
                                    <defs>
                                        <linearGradient
                                            id="paint0_linear_273_6915"
                                            x1="20.6"
                                            y1="8.95028"
                                            x2="-0.0180169"
                                            y2="11.3301"
                                            gradientUnits="userSpaceOnUse"
                                        >
                                            <stop stop-color="#033D9B" />
                                            <stop offset="1" stop-color="#29ACD5" />
                                        </linearGradient>
                                        <linearGradient
                                            id="paint1_linear_273_6915"
                                            x1="20.6"
                                            y1="8.95028"
                                            x2="-0.0180169"
                                            y2="11.3301"
                                            gradientUnits="userSpaceOnUse"
                                        >
                                            <stop stop-color="#033D9B" />
                                            <stop offset="1" stop-color="#29ACD5" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </button>
                            <button
                                type="button"
                                className="book-page-camera-button-input-2"
                                onClick={() => cusSearch("isbn", true)}
                                data-track="ExceptionBookAction-search-isbn"
                                disabled={isDisabled}
                            >
                                <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM11.0303 6.46967C10.7374 6.17678 10.2626 6.17678 9.96967 6.46967C9.67678 6.76256 9.67678 7.23744 9.96967 7.53033L12.4393 10L9.96967 12.4697C9.67678 12.7626 9.67678 13.2374 9.96967 13.5303C10.2626 13.8232 10.7374 13.8232 11.0303 13.5303L14.0303 10.5303C14.3232 10.2374 14.3232 9.76256 14.0303 9.46967L11.0303 6.46967ZM5.96967 6.46967C6.26256 6.17678 6.73744 6.17678 7.03033 6.46967L10.0303 9.46967C10.3232 9.76256 10.3232 10.2374 10.0303 10.5303L7.03033 13.5303C6.73744 13.8232 6.26256 13.8232 5.96967 13.5303C5.67678 13.2374 5.67678 12.7626 5.96967 12.4697L8.43934 10L5.96967 7.53033C5.67678 7.23744 5.67678 6.76256 5.96967 6.46967Z"
                                        fill="url(#paint0_linear_5193_31720)"
                                    />
                                    <defs>
                                        <linearGradient
                                            id="paint0_linear_5193_31720"
                                            x1="20.6"
                                            y1="9.94475"
                                            x2="-0.0696504"
                                            y2="12.0919"
                                            gradientUnits="userSpaceOnUse"
                                        >
                                            <stop stop-color="#033D9B" />
                                            <stop offset="1" stop-color="#29ACD5" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </button>
                        </div>
                    </div>

          {}
          <div className="table-container reducedbottom-padding-1">
            <div className="rounded-table-wrapper">
              <Table
                columns={columns}
                loading={loading}
                dataSource={data}
                className="common-grid withScanner"
                pagination={false}
                rowKey={(record) => record.rackNo}
                scroll={{ x: "max-content", y: "calc(100vh - 390px)" }}
                rowClassName={getRowClassName}
                onChange={handleTableChange}
              />
            </div>
          </div>
          {}
          <div className="book-page-footer-container">
            <div className="book-page-action-container">
              <div></div>
              <div className="book-page-buttons-container">
                <button
                  className="download-button-outline-manifest"
                  onClick={handleClear}
                >
                  <span></span>
                  <span>Clear</span>
                </button>
                <button
                  className="accept-button"
                  data-track="ExceptionBookAction-proceed"
                  disabled={isDisabled}
                  onClick={handleDrawerVisible}
                >
                  {}
                  Proceed
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};
export default ExceptionBookAction;
